module.exports = __webpack_public_path__ + "img/49.b571e43b.png";